module.exports = __webpack_public_path__ + "img/ghost.fe89da27.gif";